import React, { useState, useEffect } from 'react';
import * as PropTypes from 'prop-types';
import { links } from 'sf-modules';
import Banner from '@/yema-designkit/webkit/molecules/Banner';
import { useRouter } from 'next/router';

const CMS_Banner = ({ content, typeName, slug }) => {
    const router = useRouter();
    const [isBlog, setIsBlog] = useState(false);

    const handleClick = () => {
        if (content.button && content.button.link)
            links.handleRedirect(content.button.link, router);
    };

    useEffect(() => {
        if (slug === 'blog' || typeName === 'BlogType') setIsBlog(true);
        else setIsBlog(false);
    }, [isBlog, slug]);

    if (!content) return '';

    return <Banner isBlog={isBlog} bannerInfo={content} handleBtnClick={handleClick} />;
};

CMS_Banner.defaultProps = {};

CMS_Banner.propTypes = {
    content: PropTypes.object.isRequired,
};

export default CMS_Banner;
